import { get_custom_list} from "./Indicators";
import {getMonthName} from "./Precipitation"
import {maplibre_str, geoserver} from "../Geoportal";
import {months} from "./SidePanel";

  const list_dekads = { "1st": "01", "2nd": "11", "3rd": "21" };
  
export function set_innitial_selected_datasets_with_timescale(data, layername,latest_timescale="03", 
                                                      years_setter=null, selected_dates_setter=null,
                                                    setter_current=null, latest_dates_setter=null, dates_setter=null, key_current=null, dekad=null) {
    var latest_year = data?.latest_year;
    var start_year = data?.start_year;
    var years = get_custom_list(start_year, latest_year);
    if (years_setter !== null){
      years_setter(years);
    }
    var selected_month = getMonthName(data?.latest_month);
    // handle case where the current selected month is not in the available months 
    var month_names_list = get_custom_list(1, data?.latest_month).map(getMonthName);
  
      selected_dates_setter({
        year: latest_year,
        month: selected_month,
        timescale: latest_timescale,
        ...(dekad !== null && { dekad })
      });
  
    var geosever_link = `${geoserver}${maplibre_str}${layername}${months[selected_month]}${latest_timescale}_view&CQL_FILTER=year=${latest_year}`;

    if (dekad !== null) {
        geosever_link = `${geoserver}${maplibre_str}${layername}${months[selected_month]}${list_dekads[dekad]}_${latest_timescale}_view&CQL_FILTER=year=${latest_year}`;
    }


    if (key_current !== null){
       setter_current({[key_current]:geosever_link});
    }else {
        
        setter_current(geosever_link);
    }
    

    latest_dates_setter({
      latest_year: latest_year,
      latest_timescale: latest_timescale,
      latest_month: data?.latest_month,
        ...(dekad !== null && { latest_dekad: dekad })
    });

    dates_setter({
      year:years,
      month:month_names_list,
      timescale:data[latest_year]?.timescale,
      ...(dekad !== null && { dekad: ['1st', '2nd', '3rd'] })
    })
    
   
  }

  